export interface NavItem {
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "国产电影", path: "/category/movie" },
  { label: "国产电视剧", path: "/category/tvseries" },
  { label: "影视资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
  { label: "联系反馈", path: "/contact" },
];

export const footerLinks = [
  {
    title: "影视导航",
    items: [
      { label: "国产电影", path: "/category/movie" },
      { label: "国产电视剧", path: "/category/tvseries" },
      { label: "影视资讯", path: "/news" },
    ],
  },
  {
    title: "关于本站",
    items: [
      { label: "关于我们", path: "/about" },
      { label: "联系反馈", path: "/contact" },
      { label: "站点首页", path: "/" },
    ],
  },
];

export const partnerLinks = [
  "国产影视观察",
  "光影评论社",
  "佳片放映室",
  "剧集研究所",
  "影视素材库",
];

export const faqs = [
  {
    q: "国产久久久提供哪些内容？",
    a: "本站专注于国产影视内容的整理与展示，涵盖国产电影与国产电视剧两大类作品，同时提供影视行业资讯、专题报道与影人访谈等阅读内容。",
  },
  {
    q: "网站上的影片可以直接在线播放或下载吗？",
    a: "本站为内容展示与资讯平台，不提供播放、下载与支付等业务功能。页面上展示的影视信息与资讯仅用于浏览与了解，具体观看方式请以官方正规渠道为准。",
  },
  {
    q: "收藏功能的数据保存在哪里？",
    a: "收藏功能基于浏览器本地存储实现，收藏记录仅保存在您当前使用的设备与浏览器中，不会上传到服务器，清除浏览器数据后收藏会一并被清空。",
  },
  {
    q: "如何反馈问题或提出建议？",
    a: "您可以通过“联系反馈”页面提交您的意见与建议，我们会认真阅读每一条反馈。若涉及内容纠错，请尽量注明具体的影片名称或资讯标题，以便我们快速定位。",
  },
];